// Mock data for Receipt admin table.
// Використовується поки BE endpoints не готові — див. services.js.
// Значення взяті з дизайну (Image #12 у Receipt Admin plan).

const b = (id, name) => ({ id, business_account: name, name })

// Mock receipt_profile для Eye → Profile details pop-up (§6.1).
// Значення взяті з дизайну (Image #17). Один шаблон на всі рядки — достатньо для demo.
const mockReceiptProfile = {
  program: "Ethoca",
  user_full_name: "Ravi Ghataode",
  user_email: "info@isadora-vale.co.uk",
  website: "https://isadora-vale.co.uk/",
  business_name: "Headlight Experts",
  business_website: "https://isadora-vale.co.uk/",
  business_description: "Handmade ceramics and homeware, shipped worldwide.",
  business_logo: {
    file_name: "logo-2024.png",
    file_url: null // no real URL — компонент рендерить placeholder-thumbnail
  },
  business_address: "14 Mill Lane, Bristol, BS1 4TR, UK",
  product_name: "Ceramics subscription",
  product_description: "Monthly box of handmade tableware.",
  support_phone: "+44 117 555 0142",
  support_email: "info@isadora-vale.co.uk",
  support_website: "https://isadora-vale.co.uk/support",
  terms_url: "https://isadora-vale.co.uk/terms",
  refund_policy_url: "https://isadora-vale.co.uk/refunds",
  cancellation_policy_url: null
}

const _mockReceiptRequestsRaw = {
  count: 66,
  next: "/user/requests/receipts/?page=2",
  previous: null,
  results: [
    {
      id: 23112,
      request_status: "pending",
      created_timestamp: "2026-07-22T15:33:00Z",
      updated_timestamp: "2026-07-22T15:33:00Z",
      is_use_another_solutions: false,
      business_account: b(101, "Isadora Vale"),
      enrollments: "Verifi",
      programs: "OI",
      merchant_descriptor: ["SP ISADORA VALE"],
      visa_arn_code_date: "2026-07-22T15:33:00Z",
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 100.0,
      user_id: 1001,
      user_full_name: "Isadora Vale",
      user_email: "isadora@example.com",
      business_url: "https://isadoravale.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23111,
      request_status: "pending",
      created_timestamp: "2026-07-22T15:31:00Z",
      updated_timestamp: "2026-07-22T15:31:00Z",
      is_use_another_solutions: false,
      business_account: b(101, "Isadora Vale"),
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["SP ISADORA VALE"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 100.0,
      user_id: 1001,
      user_full_name: "Isadora Vale",
      user_email: "isadora@example.com",
      business_url: "https://isadoravale.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 19825,
      request_status: "needs_assistance",
      created_timestamp: "2026-07-18T11:02:00Z",
      updated_timestamp: "2026-07-21T09:14:00Z",
      is_use_another_solutions: false,
      business_account: b(102, "BrickedRx"),
      enrollments: "Verifi",
      programs: "OI",
      merchant_descriptor: ["BRICKEDRX"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 167.0,
      user_id: 1002,
      user_full_name: "BrickedRx Team",
      user_email: "team@brickedrx.com",
      business_url: "https://brickedrx.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23110,
      request_status: "active",
      created_timestamp: "2025-11-11T10:49:00Z",
      updated_timestamp: "2026-07-20T14:20:00Z",
      is_use_another_solutions: false,
      business_account: b(103, "Shabby bear cottage"),
      enrollments: "Verifi",
      programs: "OI",
      merchant_descriptor: ["SP SHABBY BEAR COTTA - 42"],
      visa_arn_code_date: "2025-11-11T10:49:00Z",
      arn_codes: [
        "74208475234100013724351",
        "74208475120100009908452",
        "74208475172100017550319",
        "74208475186100020572340"
      ],
      bin_codes: [],
      caid_codes: [],
      balance_current: 7.0,
      user_id: 1003,
      user_full_name: "Shabby Bear",
      user_email: "hello@shabbybear.com",
      business_url: "https://shabbybear.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 22935,
      request_status: "active",
      created_timestamp: "2026-07-09T08:40:00Z",
      updated_timestamp: "2026-07-19T13:05:00Z",
      is_use_another_solutions: false,
      business_account: b(104, "Sprivat"),
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["SP SPRIVAT WILMINGTON"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 138.0,
      user_id: 1004,
      user_full_name: "Sprivat Support",
      user_email: "support@sprivat.io",
      business_url: "https://sprivat.io",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23109,
      request_status: "pending",
      created_timestamp: "2026-07-22T00:58:00Z",
      updated_timestamp: "2026-07-22T00:58:00Z",
      is_use_another_solutions: false,
      business_account: null,
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["CERTIFICADO ASIST"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 0,
      user_id: 1005,
      user_full_name: "Certificado Team",
      user_email: "billing@certificado.mx",
      business_url: "https://certificado.mx",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: true
    },
    {
      id: 23108,
      request_status: "in_progress",
      created_timestamp: "2026-07-21T18:22:00Z",
      updated_timestamp: "2026-07-22T08:10:00Z",
      is_use_another_solutions: false,
      business_account: b(106, "Headlight Experts"),
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["HEADLIGHT EXPERTS 949-86*"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 112.0,
      user_id: 1006,
      user_full_name: "Headlight Team",
      user_email: "support@headlightexperts.com",
      business_url: "https://headlightexperts.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23107,
      request_status: "active",
      created_timestamp: "2026-07-05T14:11:00Z",
      updated_timestamp: "2026-07-18T10:41:00Z",
      is_use_another_solutions: false,
      business_account: b(107, "Nordic Supply"),
      enrollments: "Verifi",
      programs: "OI",
      merchant_descriptor: ["NORDIC SUPPLY AS"],
      visa_arn_code_date: "2026-07-05T14:11:00Z",
      arn_codes: ["74208475234100013724351", "74208475120100009908452"],
      bin_codes: [],
      caid_codes: [],
      balance_current: 254.0,
      user_id: 1007,
      user_full_name: "Nordic Supply",
      user_email: "hello@nordicsupply.no",
      business_url: "https://nordicsupply.no",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23106,
      request_status: "unenrolled",
      created_timestamp: "2026-07-02T09:33:00Z",
      updated_timestamp: "2026-07-17T16:52:00Z",
      is_use_another_solutions: false,
      business_account: b(108, "Palma Goods"),
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["SP PALMA GOODS"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 0,
      user_id: 1008,
      user_full_name: "Palma Goods",
      user_email: "contact@palmagoods.com",
      business_url: "https://palmagoods.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23105,
      request_status: "needs_assistance",
      created_timestamp: "2026-06-28T17:47:00Z",
      updated_timestamp: "2026-07-16T23:20:00Z",
      is_use_another_solutions: false,
      business_account: b(109, "Bright Labs"),
      enrollments: "Verifi",
      programs: "OI",
      merchant_descriptor: ["BRIGHT LABS IO"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 42.0,
      user_id: 1009,
      user_full_name: "Bright Labs",
      user_email: "hello@brightlabs.io",
      business_url: "https://brightlabs.io",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23104,
      request_status: "active",
      created_timestamp: "2026-06-25T07:05:00Z",
      updated_timestamp: "2026-07-15T09:00:00Z",
      is_use_another_solutions: false,
      business_account: b(110, "Kurata Kobe"),
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["KURATAKOBE* SUB"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 318.0,
      user_id: 1010,
      user_full_name: "Kurata Kobe",
      user_email: "hello@kuratakobe.jp",
      business_url: "https://kuratakobe.jp",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23103,
      request_status: "unenrolled",
      created_timestamp: "2026-06-24T15:12:00Z",
      updated_timestamp: "2026-07-14T08:41:00Z",
      is_use_another_solutions: false,
      business_account: b(111, "Evelyn Rowe"),
      enrollments: "Ethoca",
      programs: "CC",
      merchant_descriptor: ["SP EVELYN ROWE"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 0,
      user_id: 1011,
      user_full_name: "Evelyn Rowe",
      user_email: "evelyn@evelynrowe.co",
      business_url: "https://evelynrowe.co",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    },
    {
      id: 23102,
      request_status: "pending",
      created_timestamp: "2026-06-23T23:20:00Z",
      updated_timestamp: "2026-07-13T14:05:00Z",
      is_use_another_solutions: false,
      business_account: b(112, "Eleanor Savannah"),
      enrollments: "Verifi",
      programs: "OI",
      merchant_descriptor: ["SP ELEANOR SAVANNAH"],
      visa_arn_code_date: null,
      arn_codes: [],
      bin_codes: [],
      caid_codes: [],
      balance_current: 74.0,
      user_id: 1012,
      user_full_name: "Eleanor Savannah",
      user_email: "hello@eleanor-s.com",
      business_url: "https://eleanor-s.com",
      admin_comment: null,
      admin_screenshots: [],
      is_archived: false,
      is_unassigned: false
    }
  ]
}

export const mockReceiptRequests = _mockReceiptRequestsRaw

// Detail-payload для Eye → Profile details (окремий GET /receipts/:id/).
// BE поверне отакий об'єкт із record-метаданими + повний receipt_profile.
export const getMockReceiptDetails = (id) => {
  const row = _mockReceiptRequestsRaw.results.find((r) => r.id === Number(id)) || {}
  return {
    ...row,
    receipt_profile: mockReceiptProfile
  }
}

export const mockReceiptFilterOptions = {
  request_status: [
    "pending",
    "in_progress",
    "in_re_enrollment",
    "verification_needed",
    "pending_unenroll",
    "needs_assistance",
    "active",
    "unenrolled",
    "enrolled_elsewhere",
    "invalid_descriptor",
    "invalid_codes",
    "banned_descriptor",
    "generic_descriptor"
  ],
  admin_comment: [],
  enrollments: ["Verifi", "Ethoca"],
  programs: ["CC", "OI"],
  is_use_another_solutions: ["true", "false"]
}

export const mockProfileExportBlob = () =>
  new Promise((resolve) =>
    setTimeout(() => {
      const blob = new Blob(["field,value\nbusiness_name,Headlight Experts"], {
        type: "text/csv"
      })
      resolve({
        ok: true,
        status: 200,
        data: blob,
        headers: { "content-disposition": 'attachment; filename="profile-details.csv"' },
        config: {},
        duration: 300,
        problem: null,
        originalError: null
      })
    }, 300)
  )

// Helper — імітує apisauce-shape response з невеликою затримкою.
export const mockResponse = (data, delayMs = 300) =>
  new Promise((resolve) =>
    setTimeout(
      () =>
        resolve({
          ok: true,
          status: 200,
          data,
          headers: {},
          config: {},
          duration: delayMs,
          problem: null,
          originalError: null
        }),
      delayMs
    )
  )
